import axios, { AxiosResponse } from 'axios';
import { AuthenticationResponse, CrsSettings, User, ServerVersionResponse } from '../domain/domain';
import { getHeaders, BASE_URL } from './common';

export function getUsers(): Promise<AxiosResponse<User[]>> {
    return axios.get(BASE_URL + `/legal/users`, { headers: getHeaders() });
}

export function updateUser(user: User): Promise<AxiosResponse<User>> {
    return axios.put(BASE_URL + `/legal/users/${user.id}`, user, { headers: getHeaders() });
}

export function login(username: string, password: string): Promise<AxiosResponse<AuthenticationResponse>> {
    return axios.post(BASE_URL + '/login', { user: username, password: password }, { headers: getHeaders() });
}

export function getCurrentUser(): Promise<AxiosResponse<User>> {
    return axios.get(BASE_URL + '/user', { headers: getHeaders() });
}

export function getCrsSettings(): Promise<AxiosResponse<CrsSettings>> {
    return axios.get(BASE_URL + '/legal/crs-settings', { headers: getHeaders() });
}

export function saveCrsSettings(crsSettings: CrsSettings): Promise<AxiosResponse<CrsSettings>> {
    return axios.put(BASE_URL + `/legal/crs-settings`, crsSettings, { headers: getHeaders() });
}

export function fetchServerVersion(): Promise<AxiosResponse<ServerVersionResponse>> {
    return axios.get(BASE_URL + `/actuator/info`, { headers: getHeaders() });
}

export function logout(): Promise<AxiosResponse<any>> {
    return axios.post(BASE_URL + '/logout', {}, { headers: getHeaders() })
        .then(response => {
            // Clear token on successful logout
            localStorage.removeItem('ACCESS_TOKEN');
            return response;
        });
}

export function sessionTimeout(): Promise<AxiosResponse<any>> {
    // Get token directly from storage
    const token = localStorage.getItem('ACCESS_TOKEN');

    // Create headers object with conditional token
    const headers: Record<string, string> = {
        'Content-Type': 'application/json'
    };

    // Only add token if it exists
    if (token) {
        headers['X-Auth-Token'] = token;
    }

    return axios.post(BASE_URL + '/session-timeout', {}, { headers })
        .then(response => {
            // Clear token on successful session timeout notification
            localStorage.removeItem('ACCESS_TOKEN');
            return response;
        });
}